import React from 'react';
import { Button, Descriptions, message } from 'antd';
import { DeleteFilled } from '@ant-design/icons';
import useAxios from './../../../CustomHooks/useAxios';

export default function DeleteTeam({ item, setRefreshSearch, setVisibleRemove }) {
    const { axiosi } = useAxios();

    const handleDelete = async () => {
        console.log("[handleDelete]:item=", item);
        try {
            const kq = await axiosi.delete(`agent_teams/${item.id}`);
            console.log("[handleDelete]:kq=", kq);
            setVisibleRemove(false);
            setRefreshSearch(pre => !pre);
        } catch (error) {
            if (error.response) {
                console.log(error.response.data);
                message.error(`Error: ${error.response.data.message || error.response.data.code}`);
            } else {
                console.log('Error', error.message);
                message.error(`Error: ${error.message}`);
            }
        }
    };

    return (<>
        <Descriptions size="small" column={1} bordered>
            <Descriptions.Item label="Company">{item.company_name}</Descriptions.Item>
            <Descriptions.Item label="Team Name">{item.name}</Descriptions.Item>
            <Descriptions.Item label="Note">{item.note || "-"}</Descriptions.Item>
            <Descriptions.Item label="Status">{item.activestatus === 1 ? "Active" : "Deactivate"}</Descriptions.Item>
        </Descriptions>
        <div style={{ marginTop: "1rem" }}>
            <label style={{ marginRight: "0.5rem" }}>Are you sure you want to delete this team?</label>
            <Button type="primary" danger onClick={handleDelete} icon={<DeleteFilled />}>Delete</Button>
        </div>
    </>);
}
